var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergeLands({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 90,
    viewBox: "0 0 93 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10678",
    "data-name": "Group 10678",
    transform: "translate(-898.477 -901.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10235",
    "data-name": "Path 10235",
    d: "M-7586.986-21786.561h14.953a.953.953,0,0,1,.724.332l16.141,18.82a.951.951,0,0,1-.1,1.34l-19.392,16.783a.948.948,0,0,1-1.258-.01l-27.13-24.211a.954.954,0,0,1-.317-.754.956.956,0,0,1,.386-.723l15.428-11.393A.955.955,0,0,1-7586.986-21786.561Zm14.515,1.9h-14.2l-14.232,10.512,25.63,22.869,18.041-15.613Z",
    transform: "translate(8520.921 22740.828)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10236",
    "data-name": "Path 10236",
    d: "M-7591.922-21816.336a.945.945,0,0,1,.659.266l18.729,17.9a.949.949,0,0,1,.294.689v10.707a.954.954,0,0,1-.953.953h-14.7l-14.351,11.3a.95.95,0,0,1-1.208-.023l-17.48-14.9a.956.956,0,0,1-.334-.717.951.951,0,0,1,.32-.721l28.387-25.211A.954.954,0,0,1-7591.922-21816.336Zm17.776,19.258-17.8-17.01-26.912,23.9,16.052,13.686,14-11.023a.95.95,0,0,1,.59-.205h14.073Z",
    transform: "translate(8519.739 22738.521)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_61",
    "data-name": "Subtraction 61",
    d: "M19.885,29.494a.94.94,0,0,1-.646-.253L.307,11.873A.955.955,0,0,1,0,11.158a.967.967,0,0,1,.328-.711L12.4,0a7.556,7.556,0,0,0,.431,2.15L2.383,11.188,20,27.36,37.6,16.967,22.654,3.611a7.1,7.1,0,0,0,.839-1.805l16.356,14.6a.961.961,0,0,1,.313.8.971.971,0,0,1-.462.731L20.366,29.36A.926.926,0,0,1,19.885,29.494Z",
    transform: "translate(928.925 909.274)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10238",
    "data-name": "Path 10238",
    d: "M-7551.55-21810.07a.958.958,0,0,1,.627.234l21.089,18.406a.952.952,0,0,1,.326.7.953.953,0,0,1-.3.713l-24.484,22.742a.953.953,0,0,1-.649.254.459.459,0,0,1-.052,0,.944.944,0,0,1-.669-.326l-16.261-18.822a.955.955,0,0,1-.231-.623v-10.908a.956.956,0,0,1,.474-.824l19.655-11.418A.955.955,0,0,1-7551.55-21810.07Zm19.666,19.381-19.778-17.26-18.59,10.8v10l15.383,17.807Z",
    transform: "translate(8520.984 22737.973)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(964.302 939.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671",
    "data-name": "Group 10671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240",
    "data-name": "Path 10240",
    d: "M81.931,0a5.932,5.932,0,0,0-5.045,9.049l4.708,7.587a.494.494,0,0,0,.42.234h0a.494.494,0,0,0,.42-.24l4.588-7.66A5.932,5.932,0,0,0,81.931,0Zm4.246,8.462-4.171,6.964-4.28-6.9a4.946,4.946,0,1,1,8.451-.067Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673",
    "data-name": "Group 10673",
    transform: "translate(2.965 2.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241",
    "data-name": "Path 10241",
    d: "M168.965,90a2.965,2.965,0,1,0,2.965,2.965A2.969,2.969,0,0,0,168.965,90Zm0,4.949a1.983,1.983,0,1,1,1.98-1.983A1.985,1.985,0,0,1,168.965,94.949Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-2",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(941.341 901.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-2",
    "data-name": "Group 10671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-2",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-2",
    "data-name": "Path 10240",
    d: "M81.931,0a5.932,5.932,0,0,0-5.045,9.049l4.708,7.587a.494.494,0,0,0,.42.234h0a.494.494,0,0,0,.42-.24l4.588-7.66A5.932,5.932,0,0,0,81.931,0Zm4.246,8.462-4.171,6.964-4.28-6.9a4.946,4.946,0,1,1,8.451-.067Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-2",
    "data-name": "Group 10673",
    transform: "translate(2.965 2.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-2",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-2",
    "data-name": "Path 10241",
    d: "M168.965,90a2.965,2.965,0,1,0,2.965,2.965A2.969,2.969,0,0,0,168.965,90Zm0,4.949a1.983,1.983,0,1,1,1.98-1.983A1.985,1.985,0,0,1,168.965,94.949Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-3",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(939.298 964.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-3",
    "data-name": "Group 10671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-3",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-3",
    "data-name": "Path 10240",
    d: "M81.931,0a5.932,5.932,0,0,0-5.045,9.049l4.708,7.587a.494.494,0,0,0,.42.234h0a.494.494,0,0,0,.42-.24l4.588-7.66A5.932,5.932,0,0,0,81.931,0Zm4.246,8.462-4.171,6.964-4.28-6.9a4.946,4.946,0,1,1,8.451-.067Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-3",
    "data-name": "Group 10673",
    transform: "translate(2.965 2.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-3",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-3",
    "data-name": "Path 10241",
    d: "M168.965,90a2.965,2.965,0,1,0,2.965,2.965A2.969,2.969,0,0,0,168.965,90Zm0,4.949a1.983,1.983,0,1,1,1.98-1.983A1.985,1.985,0,0,1,168.965,94.949Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Map_pin_-_Flaticon-3-4",
    "data-name": "Search results for Map pin - Flaticon-3",
    transform: "translate(914.528 934.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671-4",
    "data-name": "Group 10671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670-4",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10240-4",
    "data-name": "Path 10240",
    d: "M81.931,0a5.932,5.932,0,0,0-5.045,9.049l4.708,7.587a.494.494,0,0,0,.42.234h0a.494.494,0,0,0,.42-.24l4.588-7.66A5.932,5.932,0,0,0,81.931,0Zm4.246,8.462-4.171,6.964-4.28-6.9a4.946,4.946,0,1,1,8.451-.067Z",
    transform: "translate(-76)",
    fill: "#00641f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10673-4",
    "data-name": "Group 10673",
    transform: "translate(2.965 2.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672-4",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10241-4",
    "data-name": "Path 10241",
    d: "M168.965,90a2.965,2.965,0,1,0,2.965,2.965A2.969,2.969,0,0,0,168.965,90Zm0,4.949a1.983,1.983,0,1,1,1.98-1.983A1.985,1.985,0,0,1,168.965,94.949Z",
    transform: "translate(-166 -90)",
    fill: "#00641f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeLands);
export default __webpack_public_path__ + "static/media/mergeLands.c73037ca34c5ddecda3821185e65b8a8.svg";
export { ForwardRef as ReactComponent };